import buildResourceSagas from 'store/configure/sagas';

import actions from './actions';

export default buildResourceSagas(actions);
